import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-english-course',
    templateUrl: './english-course.component.html',
    styleUrls: ['./english-course.component.scss'],
    standalone: false
})
export class EnglishCourseComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
